import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import type { IAffiliateWebhooksHistoryListItem } from '@modules/webhooks-history/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  WEBHOOKS_HISTORY_LIST_API_URL,
  WEBHOOKS_HISTORY_LIST_QUERY_KEY,
  WEBHOOKS_HISTORY_PERMISSIONS,
} from '@modules/webhooks-history/constants';
import { keepPreviousData } from '@tanstack/vue-query';

export default function useWebhooksHistoryListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<
    ITableDataResponse<IAffiliateWebhooksHistoryListItem>,
    Error
  > {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliateWebhooksHistoryListItem>>({
    queryKey: [WEBHOOKS_HISTORY_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliateWebhooksHistoryListItem>>(
      WEBHOOKS_HISTORY_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: WEBHOOKS_HISTORY_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
